import React from "react";
import PropTypes from "prop-types";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useDispatch } from "react-redux";
import { updateElement } from "../../../store/formSlice";
import { Box } from "@mui/material";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";

const DatePickerComponent = ({
  elementId,
  label,
  value,
  required,
  width,
  height,
  marginLeft,
  marginTop,
}) => {
  const dispatch = useDispatch();

  const handleChange = (newValue) => {
    if (newValue && newValue.isValid()) {
      const updatedElement = {
        element: {
          elementId: elementId,
          label,
          value: newValue.toISOString(),
        },
      };
      dispatch(updateElement(updatedElement));
    }
  };

  return (
    <Box
      sx={{
        width: {
          xs: width, // Full width on extra-small screens
          sm: width, // 75% width on small screens
          md: width, // 50% width on medium screens
          lg: width, // Use provided width on large screens
          xl: width, // Use provided width on extra-large screens
        },
        height: {
          xs: "auto", // Auto height on extra-small screens
          sm: "auto", // Auto height on small screens
          md: "auto", // Auto height on medium screens
          lg: height, // Use provided height on large screens
          xl: height, // Use provided height on extra-large screens
        },
        marginTop: marginTop || "10px",
        marginLeft: marginLeft || "0",
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer components={["DatePicker"]}>
          <DatePicker
            label={label}
            value={value ? dayjs(value) : null} // Ensure the value is a dayjs object
            onChange={handleChange}
            fullWidth
            inputFormat="DD/MM/YYYY"
            renderInput={(params) => <TextField {...params} />}
          />
        </DemoContainer>
      </LocalizationProvider>
    </Box>
  );
};

DatePickerComponent.propTypes = {
  elementId: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired, // Expecting ISO string for date
};

export default DatePickerComponent;
